// Viewport-specific spacing for Hero section
export const HERO_SPACING = {
  mobile: {
    contentTopPadding: '100px',
    titleToSeparator: '20px',
    separatorTopMargin: '14px',
    separatorBottomMargin: '14px'
  },
  tablet: {
    contentTopPadding: '140px',
    titleToSeparator: '24px',
    separatorTopMargin: '16px',
    separatorBottomMargin: '16px'
  },
  narrow: {
    contentTopPadding: '160px',
    titleToSeparator: '22px',
    separatorTopMargin: '15px',
    separatorBottomMargin: '15px'
  },
  desktop: {
    contentTopPadding: '180px',
    titleToSeparator: '20px',
    separatorTopMargin: '12px',
    separatorBottomMargin: '12px'
  },
  wide: {
    contentTopPadding: '200px',
    titleToSeparator: '28px',
    separatorTopMargin: '18px',
    separatorBottomMargin: '18px'
  }
}; 